import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { getSickDay } from '../../../services/ApiGetSickDay';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';
import { SickLeave } from '../../../model/datatype';

export const TimeSickDay = (props: any) => {
  let { t } = useTranslation();
  const [data, setData] = useState<SickLeave | null>(null);

  useEffect(() => {
    if (data === null) {
      getSickDay(0, 0, props.email).then((response: any) => {
        const getData: any = response;
        setData(getData);
      });
    }
  }, [data]);

  //console.log('getSickDay=',data);

  return (
    <div className="TimeInout_ThisWeek_detail text-center">
      <Row className="m-auto">
        <Col className="px-1">
          <div className="time_late_this_week_detail_box">
            <div className="Time_sick_ThisWeek_detail_text">
              {t('time_list_box.timeanddate_sick.title')}
            </div>
            <Row className="sick-this-week-title-box m-1">
              <Col xs={4} className="this-week-title px-1">
                {t('time_list_box.timeanddate_sick.date')}
              </Col>
              <Col xs={2} className="this-week-title px-1">
                {t('time_list_box.timeanddate_sick.hour')}
              </Col>
              <Col xs={6} className="this-week-title px-1">
                {t('time_list_box.timeanddate_sick.remark')}
              </Col>
            </Row>
            <div className="w-100 table-container">
              {typeof data?.leaveDetailsInfos !== 'undefined' ? (
                data?.leaveDetailsInfos.length > 0 ? (
                  data?.leaveDetailsInfos.map((item: any, index: number) => (
                    <Row
                      className="late_time-in-out-list  m-1 mt-3"
                      key={index}
                    >
                      <Col
                        xs={4}
                        className="late_this-week-title-val px-1 text-center"
                      >
                        {Moment(item.dateWork).format('DD/M/YYYY')}
                      </Col>
                      <Col
                        xs={3}
                        className="late_this-week-title-val px-1 text-center"
                      >
                        {item.qtyStr}{' '}
                        {t('time_list_box.timeanddate_vacation_leave.hour')}
                      </Col>
                      <Col
                        xs={5}
                        className="late_this-week-title-val px-1 text-center text-truncate"
                      >
                        {item.descriptionTH ? item.descriptionTH : '-'}
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="loader-data text-notfound">
                    {t('text_notfound')}
                  </div>
                )
              ) : (
                <div className="loader-data">
                  <div className="spinner"></div>
                </div>
              )}
            </div>
            <Row className="late_time-in-out-list line-total m-1 mt-3">
              <Col xs={4} className="this-week-title-val px-1 text-center">
                <strong className="stick-time-in-out-this-week-total">
                  {t('time_list_box.timeanddate_sick.total')}
                </strong>
              </Col>
              <Col xs={2}></Col>
              <Col xs={6} className="this-week-title-val px-1 text-center">
                <strong className="stick-time-in-out-this-week-total">
                  {data?.summary} {t('time_list_box.timeanddate_sick.unit')}
                </strong>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="m-2"></Col>
      </Row>
    </div>
  );
};
